import { BRAND_STYLES } from 'lib/constants/brandPalette';

import RadioButton from 'components/shared/RadioButton/RadioButton';

import OptionCard from './OptionCard';
import BrandSwatch from './BrandSwatch';

const STYLE_OPTIONS = [
  {
    value: BRAND_STYLES.SINGLE,
    title: 'Single color',
    description: 'One brand color everywhere. Calm and consistent.'
  },
  {
    value: BRAND_STYLES.TWO,
    title: 'Two colors',
    description: 'Brand color for main components, accent color for other details.'
  }
];

const StyleSelector = ({ value, primary, accent, onChange }) => (
  <div className="flex flex-col gap-3">
    {STYLE_OPTIONS.map((option) => {
      const isSelected = value === option.value;
      return (
        <OptionCard
          key={option.value}
          isSelected={isSelected}
          onSelect={() => onChange(option.value)}
          className="gap-3 py-3 pl-4 pr-5 sm:gap-2 sm:px-3 xs:gap-3 xs:pl-4 xs:pr-5"
          data-qa={`brand-style-${option.value}`}>
          <div className="flex shrink-0 items-center gap-2 sm:gap-1 xs:gap-2">
            <RadioButton
              name="brand-style"
              value={option.value}
              isSelected={isSelected}
              onChange={() => onChange(option.value)}
              label=""
              wrapperClassName="!w-auto"
              tabIndex={-1}
              wrapperTabIndex={-1}
            />
            <BrandSwatch
              primary={primary}
              accent={accent}
              isTwoColor={option.value === BRAND_STYLES.TWO}
              size={72}
              className="sm:h-12 sm:w-12 xs:h-[72px] xs:w-[72px]"
            />
          </div>
          <div className="flex min-w-0 flex-1 flex-col">
            <p className="text-base font-500 leading-6 text-neutral-900">{option.title}</p>
            <p className="text-sm leading-[22px] text-neutral-700">{option.description}</p>
          </div>
        </OptionCard>
      );
    })}
  </div>
);

export default StyleSelector;
